// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__tVSjJ","empty__label":"styles_empty__label__kup+v"};